// @ts-nocheck
import { Logo } from "react-components";
import React, { useContext, useState } from "react";
import cn from "classnames";

import PropTypes from "prop-types";

import useEffectOnce from "../../hooks/useEffectOnce";

import AnchorLink from "../anchorLink";
import { UtmParamsContext } from "../../context/utmParams";
import { getSearchFromObjectParams } from "../../helpers/urlUtils";

import SubMenu from "./subMenu";
import HamburgerButton from "./hamburgerButton";

import styles from "./styles.css";

export default function PageNav({ appearance = "transparent-black-text", items, pageNavContainerBg }) {
    const isTransparent = appearance !== "solid-white";
    const isDefaultDarkBackground = appearance === "transparent-white-text";
    const { utmParams } = useContext(UtmParamsContext);
    const [isDarkBackground, setIsDarkBackground] = useState(isDefaultDarkBackground);
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [isNavClosing, setIsNavClosing] = useState(false);
    const [backgroundColor, setBackgroundColor] = useState(`rgba(255, 255, 255, ${isTransparent ? 0 : 1})`);
    const [paddingSize, setPaddingSize] = useState(isTransparent ? 24 : 0);

    let isNavClosingTimer;

    function handleResize() {
        setIsNavOpen(false);
    }

    function handleScroll() {
        const opacity = window.scrollY / 200;
        setBackgroundColor(`rgba(255, 255, 255, ${opacity})`);
        const padding = 24 - window.scrollY / 50;
        setPaddingSize(padding || 0);
        setIsDarkBackground(isDefaultDarkBackground && opacity <= 0.5);
    }

    useEffectOnce(() => {
        if (isTransparent) {
            window.addEventListener("resize", handleResize);
            window.addEventListener("scroll", handleScroll);

            return () => {
                window.removeEventListener("resize", handleResize);
                window.removeEventListener("scroll", handleScroll);
            };
        }
    });

    function toggleNavOpenState() {
        setIsNavOpen(!isNavOpen);

        if (isNavOpen) {
            global.clearTimeout(isNavClosingTimer);
            setIsNavClosing(true);

            isNavClosingTimer = global.setTimeout(() => {
                setIsNavClosing(false);
            }, 300);
        }
    }

    const darkBackground = isDarkBackground && !(isNavOpen || isNavClosing);

    return (
        <div className={cn(styles.container, styles[`container--background-${pageNavContainerBg}`])}>
            <div
                className={cn(styles.pageNav, "js-page-nav", {
                    [styles.darkBackground]: darkBackground,
                })}
                style={{
                    backgroundColor,
                    paddingTop: `${paddingSize}px`,
                    paddingBottom: `${paddingSize}px`,
                }}
            >
                <div className={styles.logoContainer}>
                    <AnchorLink href={"/"} className={styles.logoLink}>
                        <Logo modifiers={["large", ...(darkBackground ? ["light"] : [])]} />
                    </AnchorLink>
                </div>

                <ul
                    className={cn(styles.nav, {
                        [styles["nav--isOpen"]]: isNavOpen || isNavClosing,
                    })}
                >
                    {items.map(({ __typename, label, path, variant, subItems }) => {
                        switch (__typename) {
                            case "ContentfulHeaderItem":
                                if (subItems && subItems.length) {
                                    return (
                                        <li key={label} className={cn(styles.navItem, styles["navItem--withSubItems"])}>
                                            <AnchorLink
                                                href={path}
                                                disabled
                                                className={cn(styles.navItemLink, styles["navItemLink--disabled"])}
                                            >
                                                {label}
                                            </AnchorLink>
                                            <svg
                                                className={styles.navItemSubIcon}
                                                width={"100%"}
                                                height={"100%"}
                                                viewBox={"0 0 24 24"}
                                                xmlns={"http://www.w3.org/2000/svg"}
                                            >
                                                <path
                                                    clipRule={"evenodd"}
                                                    d={
                                                        "m14.0429 3.29289c.3905-.39052 1.0236-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422l-7.29291 7.29289 7.29291 7.2929c.3905.3905.3905 1.0237 0 1.4142-.3906.3905-1.0237.3905-1.4142 0l-7.29293-7.2929c-.99996-.9142-.99997-1.9142 0-2.8284z"
                                                    }
                                                    fillRule={"evenodd"}
                                                />
                                            </svg>

                                            <SubMenu subItems={subItems} />
                                        </li>
                                    );
                                }

                                return (
                                    <li key={label} className={styles.navItem}>
                                        <AnchorLink href={path} className={styles.navItemLink}>
                                            {label}
                                        </AnchorLink>
                                    </li>
                                );

                            case "ContentfulHeaderButton": {
                                const buttonModifiers = ["button", "button-small"];

                                if (darkBackground) {
                                    buttonModifiers.push("button-white");
                                }

                                if (variant === "outlined") {
                                    buttonModifiers.push("button-outlined");
                                }

                                if (variant === "secondary" && !darkBackground) {
                                    buttonModifiers.push("button-secondary");
                                }

                                const utmSearch = getSearchFromObjectParams(utmParams);

                                return (
                                    <li key={label} className={styles.navButton}>
                                        <AnchorLink
                                            href={path + utmSearch}
                                            className={cn(styles.navButtonLink, styles[`navButtonLink--${variant}`])}
                                            modifiers={buttonModifiers}
                                        >
                                            {label}
                                        </AnchorLink>
                                    </li>
                                );
                            }
                        }
                        return null;
                    })}
                </ul>

                <HamburgerButton isNavOpen={isNavOpen} onClick={toggleNavOpenState} />
            </div>
        </div>
    );
}

PageNav.propTypes = {
    items: PropTypes.array,
};
